export enum EnActivityStatus {
    late = 'late',
    pending = 'pending',
    todo = 'todo',
    done = 'done',
    warn = 'warn',
    extra = 'extra'
}
